import { useState, useRef } from 'react';
import { Snackbar, Alert as MuiAlert } from '@mui/material';
import { useTraderSubscription } from './hooks/useTraderSubscription';
import { useFcmToken } from './hooks/useFcmToken';
import { SubscribeButton } from './SubscribeButton';

export interface TraderSubscribeBellProps {
    address: string;
    /** Optional display label (e.g. ENS / short address). */
    label?: string;
}

export function TraderSubscribeBell({ address, label }: TraderSubscribeBellProps) {
    const anchorRef = useRef<HTMLButtonElement>(null);
    const [snack, setSnack] = useState<string | null>(null);
    const { subscription, loading, loggedIn, subscribe, unsubscribe } = useTraderSubscription(address);
    const { ensureToken } = useFcmToken();

    // Mirror the event/market bell: only shown to signed-in users.
    if (loading || !loggedIn) return null;
    const isSubscribed = !!subscription;

    return (
        <>
            <SubscribeButton
                ref={anchorRef}
                subscribed={isSubscribed}
                onClick={async () => {
                    if (isSubscribed) {
                        await unsubscribe();
                        setSnack('Unsubscribed');
                    } else {
                        await ensureToken();
                        await subscribe({ min_severity: 'info', trader_label: label ?? address });
                        setSnack(`Subscribed to ${label ?? address}`);
                    }
                }}
            />
            <Snackbar
                open={!!snack}
                autoHideDuration={3000}
                onClose={() => setSnack(null)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <MuiAlert severity="success" onClose={() => setSnack(null)}>{snack}</MuiAlert>
            </Snackbar>
        </>
    );
}
